const FRONTEND = "https://www.app.outdefine.com/";

export const outdefineURLs =  {
    frontend: {
        main: FRONTEND,
        jobPost: (id: number) => `${FRONTEND}jobs/post/${id}`
    }
}